
<div class="container">
 
  <h2 class="content-heading">
    <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
      <i class="fa fa-plus mr-5"></i>Add Calendar Item
    </button>
    Calendar Item
  </h2>
 
  <div class="blockX">
 
    <div class="block-contentX">
 
        <div class=row>

            <div class="col-sm-5">
<!-- 
              Show
              <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
                <option value=15>15</option>
                  <option value=30>30</option>
                  <option value=60>60</option>
                  <option value=99999>All</option>
              </select>
              entries -->
            </div>

            <div class="col-sm-7 text-right">
                Filter: <input type="text" [(ngModel)]="search">
            </div>

          </div>

  <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">

      <div class="xrow header gridRow row">
          <div class="col-md-3">Name</div>
          <div class="col-md-4">Description</div>
          <div class="col-md-4">Recurring Description</div>
          <div class="col-md-1"></div>
      </div>


    <div id="scrollableTable">
        <div class="">
          <div *ngFor="let obj of entities | serviceFilter: search" class="dateRow gridRow row">

            <div class="col-md-3">{{obj.Name}}</div>
            <div class="col-md-4">{{obj.Description}}</div>
            <div class="col-md-4">{{obj.AlternateName}}</div>
            <div class="col-md-1">
                <div class="btn-group">
                    <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                        <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>

    </div>
 
        </div>
 
        <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>
  </div>

</div>


